import { render, staticRenderFns } from "./ToDoItem.vue?vue&type=template&id=5be81f36&scoped=true"
import script from "./ToDoItem.vue?vue&type=script&lang=js"
export * from "./ToDoItem.vue?vue&type=script&lang=js"
import style0 from "./ToDoItem.vue?vue&type=style&index=0&id=5be81f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be81f36",
  null
  
)

export default component.exports